var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLhLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 548.20728733",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#0535c1",
    fillRule: "nonzero",
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.273 116.364h151.272v151.272h-151.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.727 179.386h-15.313c-7.62-21.77-29.847-34.855-52.58-30.955s-39.326 23.646-39.254 46.71c.006 26.11 21.17 47.273 47.278 47.28h59.87c16.998-.566 30.485-14.51 30.485-31.518s-13.487-30.951-30.486-31.517z",
    fill: "#eaeaea",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.25 211.293v-.384c-.006-17.407-14.116-31.516-31.523-31.523h-15.755v.791h15.755c17.248-.001 31.294 13.859 31.523 31.104z",
    fill: "#fff",
    fillOpacity: 0.2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.858 147.887 25.554 80.71c8.54-8.577 21.713-20.4 21.713-33.444-.006-26.108-21.17-47.272-47.278-47.278z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.858,
    cy: 195.153,
    fill: "#eee",
    r: 47.279
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.858 148.666c25.955.012 47.05 20.94 47.267 46.895v-.384c.01-26.108-21.147-47.28-47.255-47.29s-47.28 21.147-47.29 47.255v.384c.236-25.945 21.332-46.855 47.278-46.86z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.727 241.63h-59.88c-25.955-.013-47.05-20.942-47.267-46.895v.384c.012 26.104 21.174 47.26 47.278 47.266h59.87c17.402-.006 31.51-14.108 31.522-31.51v-.385c-.216 17.257-14.265 31.134-31.523 31.14z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.182 107.636h133.818v116.364h-133.818z",
    fill: "#fff176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.636 285.09h160v160h-160z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f4481e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m349.09 212.364h23.274v46.545h-232.728v-46.545h23.273v-93.091l93.091-58.183 93.09 58.182zm-46.545 0v-67.294l-46.545-29.09-46.545 29.09v67.294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.303 478.499 39.424-266.135h174.546l39.424 266.135a254.836 254.836 0 0 1 -126.697 33.501 254.836 254.836 0 0 1 -126.697-33.501zm178.817-185.833-109.499 35.574-13.311 89.83 134.889-43.834z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m55.273 165.818h174.545v174.546h-174.545z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m186.182 238.545h-17.676c-8.83-25.075-34.455-40.129-60.657-35.632-26.202 4.498-45.341 27.235-45.304 53.82.02 30.118 24.434 54.527 54.552 54.54h69.085c19.725-.5 35.455-16.633 35.455-36.364s-15.73-35.865-35.455-36.364z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.545 275.34v-.43c0-20.074-16.29-36.365-36.363-36.365h-18.188v.908h18.188c19.895.005 36.096 15.993 36.363 35.887z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.097 202.182 29.475 93.114c9.856-9.89 25.053-23.529 25.053-38.586-.02-30.114-24.426-54.52-54.54-54.54z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.097,
    cy: 256.733,
    fill: "#fff",
    r: 54.551
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.097 203.09c29.946.018 54.284 24.163 54.54 54.109v-.431a54.545 54.545 0 1 0 -109.092-.035v.43c.269-29.938 24.612-54.068 54.552-54.074z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.182 310.365h-69.097c-29.946-.018-54.284-24.164-54.54-54.109v.43c.013 30.123 24.43 54.539 54.552 54.552h69.085c20.073 0 36.363-16.291 36.363-36.364v-.442c-.242 19.912-16.45 35.928-36.363 35.933z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 2.676c140.94 0 255.244 113.885 255.977 254.662l.023-1.338c0-141.382-114.618-256-256-256s-256 114.618-256 256c0 .442.035.873.035 1.338.721-140.765 115.002-254.662 255.965-254.662z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.977 254.662c-.745 140.777-115.037 254.662-255.977 254.662-140.951 0-255.244-113.897-255.965-254.662 0 .465-.035.896-.035 1.338 0 141.382 114.618 256 256 256s256-114.618 256-256z",
    fill: "#263238",
    fillOpacity: 0.2
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLhLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lh_logo.93f22c6a.svg";
export { ForwardRef as ReactComponent };